//@vendor
const React = require('react');
const PropTypes = require('prop-types');

//@utilities
const { formatText } = require('core/i18n').i18n;

//@commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const getLast6Months = require('components/commons/last6MonthsFilter/last6MonthsFilter');
const OKModal = require('components/commons/OKModal/OKModal');

class OpenYoungCardBudgetFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            monthSelected: this.props.selectedMonth
        };

        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
    }

    handleOnSubmit() {
        const { monthSelected } = this.state;
        this.props.onFilterSubmitClick(monthSelected);
        this.props.onCloseClick();
    }

    handleMonthChange(value) {
        this.setState({
            monthSelected: value.value
        });
    }

    buildMonthFilter() {
        const last6Months = getLast6Months();
        return (
            <OKSelect
                name="card-chores-month-filter-dropdown"
                label={formatText('openYoungBudgetFilter-label')}
                onChange={this.handleMonthChange}
                value={this.state.monthSelected}
                options={last6Months}
                searchable={false}
                clearable={false}
                placeholder={formatText('openYoungBudgetFilter-placeholder')}
            />
        );
    }

    render() {
        const { isOpen, onCloseClick } = this.props;
        const monthFilter = this.buildMonthFilter();
        return (
            <OKModal
                content={monthFilter}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleOnSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="cards-filterMovements"
            />
        );
    }
}

OpenYoungCardBudgetFilter.propTypes = {
    immFilters: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onFilterSubmitClick: PropTypes.func.isRequired,
    selectedMonth: PropTypes.string
};

module.exports = OpenYoungCardBudgetFilter;
